import { TopBar, Navigation } from '@/components/Navigation';
import { Hero } from '@/components/home/Hero';
import { StatsStrip } from '@/components/home/StatsStrip';
import { CrossFitIntro } from '@/components/home/CrossFitIntro';
import { Gallery } from '@/components/home/Gallery';
import { Services } from '@/components/home/Services';
import { CoachSection } from '@/components/home/CoachSection';
import { Memberships } from '@/components/home/Memberships';
import { Testimonials } from '@/components/home/Testimonials';
import { Promo } from '@/components/home/Promo';
import { FAQ } from '@/components/home/FAQ';
import { QuickContactForm } from '@/components/home/QuickContactForm';
import { Footer } from '@/components/Footer';
import { ScrollProgressBar } from '@/components/ScrollProgressBar';
import { PageMeta, FAQJsonLd, BreadcrumbJsonLd, ReviewsJsonLd } from '@/components/PageMeta';

const homeFaqs = [
  { q: "Puis-je essayer avant de m'inscrire ?", a: "Oui ! Contactez-nous pour réserver un cours d'essai gratuit et découvrir notre box CrossFit à Saint-Chamond." },
  { q: "Y a-t-il un engagement ?", a: "Non, nos abonnements sont sans engagement. Vous pouvez résilier à tout moment avec un préavis de 2 mois." },
  { q: "Qu'est-ce que le Free Access ?", a: "Le Free Access est un créneau d'entraînement en accès libre, sans coach. Disponible pour les abonnements 3x/semaine et Illimité." },
  { q: "Les débutants sont-ils les bienvenus ?", a: "Absolument ! Nos coachs adaptent chaque exercice à votre niveau. Tous nos programmes sont accessibles à tous." },
  { q: "Qu'est-ce que le HYROX ?", a: "HYROX est un format de compétition fitness combinant courses et exercices fonctionnels. Nous proposons des entraînements spécifiques HYROX à Saint-Chamond." },
  { q: "Quels sont les frais d'adhésion ?", a: "Les frais d'adhésion sont de 99€. Les abonnements vont de 59€ à 99€/mois selon la formule choisie." },
];

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <PageMeta
        path="/"
        description="CrossFit Saint-Chamond & HYROX Training Club. Salle de CrossFit à Saint-Chamond (42400, Loire). WOD, HYROX, Team WOD, coaching sportif. 7 Rue Jean-Jacques Rousseau. À partir de 59€/mois sans engagement."
      />
      <FAQJsonLd faqs={homeFaqs} />
      <BreadcrumbJsonLd items={[{ name: 'Accueil' }]} />
      <ReviewsJsonLd />
      <ScrollProgressBar />
      <TopBar />
      <Navigation />
      <Hero />
      <QuickContactForm />
      <StatsStrip />
      <CrossFitIntro />
      <Gallery />
      <Services />
      <CoachSection variant="home" />
      <Promo />
      <Memberships />
      <Testimonials />
      <FAQ />
      <Footer />
    </div>
  );
}
